import React from "react"
import { Link } from "../../../server/router"

const PasswordResetRequestActionButtons = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontWeight: 400,
                fontSize: "1rem",
                lineHeight: "1.5",
                paddingTop: "1rem",
            }}
            className="login-action-bts">
            <Link href="/login">Sign In</Link>
        </div>
    )
}

export default PasswordResetRequestActionButtons
